module.exports = __webpack_public_path__ + "media/store/images/Rectangle 7-5a29e92d24dafd74a094f44993b5ae19.png";